import { FunctionComponent } from 'react';
import { DeliveryMethodHighlight } from './DeliveryMethodHighlight';
import { TravelHighlight } from './TravelHighlight';
import { LocationHighlight } from './LocationHighlight';
import { CourseDurationHighlight } from './CourseDurationHighlight';
import { LevelHighlight } from './LevelHighlight';
import { RequestDurationHighlight } from './RequestDurationHighlight';
import styles from './styles.module.scss';
import { PublicCourse, PublicOccurrence } from '@cademy-package/sdk-component-types';

export type CourseHighlightProps = {
    course: PublicCourse;
    occurrences: PublicOccurrence[] | null;
};

export const CourseHighlights: FunctionComponent<CourseHighlightProps> = ({
    course,
    occurrences,
}) => {
    return (
        <ul className={styles.list} tabIndex={0}>
            <DeliveryMethodHighlight course={course} occurrences={occurrences} />
            <TravelHighlight course={course} />
            <LocationHighlight course={course} />
            <RequestDurationHighlight course={course} />
            <CourseDurationHighlight course={course} occurrences={occurrences} />
            <LevelHighlight course={course} />
        </ul>
    );
};
